const invoicingCategories = [
	{ value: 'eu-company', label: 'EU Company' },
	{ value: 'eu-person', label: 'EU Person' },
	{ value: 'belgium', label: 'Belgium' },
	{ value: 'world', label: 'World' },
];

export default invoicingCategories;
